import { ReactNode } from "react";
import { IProgram } from "src/pages/Projects/Program/interface";
import { PhaseAgile } from "../../interface";

export interface IListProjectsLevel {
	data: IListProjectLevelData[];
    filter?: (a: any, index?: number | undefined) => boolean;
    showHeader: boolean;
    imageOnly: boolean;
    options: (row: any) => ReactNode;
}

export interface IListProjectLevelData{
    id: number;
    level: number;
	name: string;
	startDate: Date;
	endDate: Date;
	perConclusion: number;
    perConclusionColor: string;
	perPrevision: number;
    parentId?: number;
    agile?: PhaseAgile;
    situation?: ProjectSituationFilter | undefined;
    count?: number;
    completed?: number;
    pra002Modelo?: number;
    users: {
        name: string;
        image: string;
    }[];
    permission: number;
    pra002Kba001Id?: number;
    controlHours?: boolean;
}

export enum ProjectSituationFilter{
    NOT_STARTED = "0",
    IN_PROGRESS = "1",
    NEXT_TO_EXPIRE = "2",
    DELAYED = "3",
    FINISHED = "4"
}

export interface IListProgram{
    program: any;
    openModalAddorChangeProject?: (projectId: number) => void;
    onCallbackAddProject?: (programId: number) => void;
    onCallbackChangeProgram?: (programId: number) => void;
    onCallbakcDeleteProgram?: (program: IProgram) => void;
}
